import { render } from "./VaultManagement.vue?vue&type=template&id=1ac4ed2e&ts=true"
import script from "./VaultManagement.vue?vue&type=script&lang=ts"
export * from "./VaultManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__